import { makeEnum } from "../../utils/enumUtils.js";

// ============================================
// SUBSCRIPTION-SPECIFIC ENUMS
// ============================================

// Subscription plan keys
export const {
  ENUM: SUBSCRIPTION_PLAN_KEYS,
  VALUES: SUBSCRIPTION_PLAN_KEY_VALUES,
} = makeEnum({
  STARTER: "STARTER",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
});

// Billing cycles
export const { ENUM: BILLING_CYCLES, VALUES: BILLING_CYCLE_VALUES } = makeEnum({
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
});

// Subscription statuses (covers the renewal lifecycle too)
export const {
  ENUM: SUBSCRIPTION_STATUSES,
  VALUES: SUBSCRIPTION_STATUS_VALUES,
} = makeEnum({
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
});

export function subscriptionStatusBadgeVariant(status) {
  switch (status) {
    case SUBSCRIPTION_STATUSES.ACTIVE:
      return "default";
    case SUBSCRIPTION_STATUSES.PENDING:
      return "secondary";
    case SUBSCRIPTION_STATUSES.REJECTED:
      return "destructive";
    case SUBSCRIPTION_STATUSES.EXPIRED:
    case SUBSCRIPTION_STATUSES.CANCELLED:
    default:
      return "outline";
  }
}

// Subscription sources
export const {
  ENUM: SUBSCRIPTION_SOURCES,
  VALUES: SUBSCRIPTION_SOURCE_VALUES,
} = makeEnum({
  SELF_SIGNUP: "self_signup",
  ADMIN: "admin",
  MIGRATION: "migration",
});

// Subscription request categories — distinguishes a row in the admin
// "Subscription Requests" list: first-time onboarding vs renewal vs mid-cycle upgrade.
export const {
  ENUM: SUBSCRIPTION_REQUEST_TYPES,
  VALUES: SUBSCRIPTION_REQUEST_TYPE_VALUES,
} = makeEnum({
  NEW: "NEW",
  RENEWAL: "RENEWAL",
  UPGRADE: "UPGRADE",
});

export function subscriptionRequestTypeBadgeVariant(type) {
  switch (type) {
    case SUBSCRIPTION_REQUEST_TYPES.NEW:
      return "default";
    case SUBSCRIPTION_REQUEST_TYPES.RENEWAL:
      return "secondary";
    case SUBSCRIPTION_REQUEST_TYPES.UPGRADE:
      return "outline";
    default:
      return "outline";
  }
}

